import { useMemo } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { getParentPath } from '@utils/helpers/pathHelpers';
import { ViewerPanel } from '@/viewer/ViewerPanel';

interface ParsedDrivePdfView {
  filePath: string;
  isPdfView: boolean;
}

type LocationLike = Pick<Location, 'pathname' | 'search'>;

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function parseDrivePdfView(location: LocationLike): ParsedDrivePdfView {
  const rawPath = location.pathname.replace(/^\/drive\/?/, '');
  const ampViewIndex = rawPath.toLowerCase().indexOf('&view=');
  const pathPart = ampViewIndex >= 0 ? rawPath.slice(0, ampViewIndex) : rawPath;
  const ampView = ampViewIndex >= 0 ? rawPath.slice(ampViewIndex + '&view='.length).split('&')[0] : '';
  const queryView = new URLSearchParams(location.search || '').get('view') || '';
  return {
    filePath: safeDecode(pathPart).replace(/^\/+|\/+$/g, ''),
    isPdfView: (queryView || ampView).toLowerCase() === 'pdf',
  };
}

export function DrivePdfViewerPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const parsed = useMemo(() => parseDrivePdfView(location), [location]);
  if (!parsed.isPdfView || !parsed.filePath) return <Navigate to="/drive" replace />;

  return (
    <ViewerPanel
      auth={{ kind: 'owner' }}
      folderPath={getParentPath(parsed.filePath)}
      filePath={parsed.filePath}
      title={parsed.filePath.split('/').pop() || 'PDF'}
      contentType="pdf"
      initialMode="pdf-reader"
      onClose={() => navigate('/drive')}
    />
  );
}
